import React, { useEffect } from "react";
import GModal from "components/ui/modal/Modal";
import { Box, Flex, Stack, useToast } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import MultiSelect from "components/ui/multiSelect/MultiSelect";
import GButton from "components/ui/button/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  AddItemForQuantityAdjusment,
  getItemsForQuantityAdjusment,
  getQuantityAdjustmentItems,
} from "../../services/quantityAdjustmentService";
import { useParams } from "react-router-dom";

const AddItemModal = ({ onClose }) => {
  const { t } = useTranslation();
  const id = useParams();
  const dispatch = useDispatch();
  const toast = useToast({
    position: "top",
    duration: 3000,
    status: "success",
  });
  const toast2 = useToast({ position: "top", duration: 3000, status: "error" });
  const { handleSubmit, setValue} =
    useForm();

  const data = useSelector((state) => state.QuantityAdjustment);


  useEffect(() => {
    dispatch(getItemsForQuantityAdjusment());
  }, [dispatch]);

  return (
    <GModal
      onClose={onClose}
      modalHeader={t("pages.quantity_adjustment.add_item")}
      modalContent={
        <Box p={4}>
          <form
            onSubmit={handleSubmit((values) => {
              values.UserId = localStorage.getItem("userId");
              if (
                values.QuantityAdjustmentItem === undefined ||
                values.QuantityAdjustmentItem.length === 0
              ) {
                toast2({ description: t("validation.choose_first") });
              } else {
                values.QuantityAdjustmentItem =
                  values.QuantityAdjustmentItem?.map((el) => ({
                    InventoryItemId: el.InventoryItemId,
                    QuantityAdjustmentId: id.id,
                  }));
                values.QuantityAdjustmentItemId = null;
                dispatch(AddItemForQuantityAdjusment(values))
                  .unwrap()
                  .then((_) => {
                    toast({
                      description: t(
                        "pages.quantity_adjustment.quantity_adjustment_item_added"
                      ),
                    });
                    dispatch(getQuantityAdjustmentItems(id.id));
                    onClose();
                  });
              }
            })}
          >
            <Stack spacing={6}>
              <MultiSelect
                title={t("pages.quantity_adjustment.items")}
                data={
                  data.items &&
                  data.items.map((el) => ({
                    ...el,
                    label: el.InventoryItemNameEng,
                    value: el.InventoryItemId,
                  }))
                }
                isMulti={true}
                isRequired={true}
                onChange={(e) => setValue("QuantityAdjustmentItem", e)}
              />

              <Flex gap={4}>
                <GButton
                  type="submit"
                  title={t("general.save")}
                  bg="primary"
                  color="light"
                  border="1px solid transparent"
                  isLoading={data.isLoading}
                  hover={{
                    color: "primary",
                    borderColor: "primary",
                    bg: "none",
                  }}
                />
                <GButton
                  title={t("general.close")}
                  onClick={onClose}
                  bg="red.600"
                  border="1px solid transparent"
                  color="light"
                  isLoading={data.isLoading}
                  hover={{
                    color: "red.600",
                    borderColor: "red.600",
                    bg: "none",
                  }}
                />
              </Flex>
            </Stack>
          </form>
        </Box>
      }
    />
  );
};

export default AddItemModal;
